import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import {
  OrderMobileStockMutationVariables,
  SyncMobileStockMutationVariables,
} from "operations/schema/schema";
import { AppAsyncThunkConfig } from "store";
import { State } from "./stock.store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();

export const asyncMutations = {
  moveMobileStock: createAppAsyncThunk(
    "stock/moveMobileStock",
    async (variables: SyncMobileStockMutationVariables, { rejectWithValue, extra: { sdk } }) => {
      const { data, errors } = await graphqlRequest(sdk.syncMobileStock, {
        variables,
      });
      if (errors) return rejectWithValue(errors);
      if (!data?.syncMobileStock) return rejectWithValue("something went wrong");
      return data;
    },
  ),
  updateMobileStock: createAppAsyncThunk(
    "stock/updateMobileStock",
    async (variables: SyncMobileStockMutationVariables, { rejectWithValue, extra: { sdk } }) => {
      const { data, errors } = await graphqlRequest(sdk.syncMobileStock, {
        variables,
      });
      if (errors) return rejectWithValue(errors);
      if (!data?.syncMobileStock) return rejectWithValue("something went wrong");
      return data;
    },
  ),
  orderMobileStock: createAppAsyncThunk(
    "stock/orderMobileStock",
    async (variables: OrderMobileStockMutationVariables, { rejectWithValue, extra: { sdk } }) => {
      const { data, errors } = await graphqlRequest(sdk.orderMobileStock, {
        variables,
      });
      if (errors) return rejectWithValue(errors);
      if (!data?.orderMobileStock) return rejectWithValue("something went wrong");
      return data;
    },
  ),
};

export const mutationBuilder = (builder: ActionReducerMapBuilder<State>) => {
  builder.addCase(asyncMutations.moveMobileStock.pending, (state) => {
    state.loadingSyncStock = true;
    return state;
  });
  builder.addCase(asyncMutations.moveMobileStock.rejected, (state) => {
    state.loadingSyncStock = false;
    return state;
  });
  builder.addCase(asyncMutations.moveMobileStock.fulfilled, (state) => {
    state.loadingSyncStock = false;
    state.stockToMove = [];
    return state;
  });

  builder.addCase(asyncMutations.updateMobileStock.pending, (state) => {
    state.loadingSyncStock = true;
    return state;
  });
  builder.addCase(asyncMutations.updateMobileStock.rejected, (state) => {
    state.loadingSyncStock = false;
    return state;
  });
  builder.addCase(asyncMutations.updateMobileStock.fulfilled, (state) => {
    state.loadingSyncStock = false;
    state.stockToUpdate = [];
    return state;
  });

  builder.addCase(asyncMutations.orderMobileStock.pending, (state) => {
    state.loadingOrderStock = true;
    return state;
  });
  builder.addCase(asyncMutations.orderMobileStock.rejected, (state) => {
    state.loadingOrderStock = false;
    return state;
  });
  builder.addCase(asyncMutations.orderMobileStock.fulfilled, (state) => {
    state.loadingOrderStock = false;
    state.stockToOrder = [];
    return state;
  });
};
